import { createContext, useContext } from "react";

export const DriverContext = createContext();

export function useDriver() {
  return useContext(DriverContext);
}
